// @ts-nocheck
import { ButtonIcon, ButtonPresentationProps } from "@insite/mobius/Button";
import { IconWrapper } from "@insite/mobius/Icon";
import { headerIconStyles } from "@store/Themes/common/mixins/header";
import { buttonResetProps } from "@store/Themes/common/props/button";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { iconScalableStyles } from "@toolkit/Themes/common/mixins";
import { css } from "styled-components";

export const headerIconButtonProps = {
    ...buttonResetProps,
    css: css`
        ${buttonResetProps.css}
        ${headerIconStyles()}
        display: flex;
        align-items: center;
        font-size: inherit;
        transition: none;

        ${ButtonIcon} {
            top: auto;
        }

        > ${IconWrapper} {
            ${x => breakpointValues(x.theme.design.header.iconButton.size.map(y => (y ? iconScalableStyles(y) : y)))}
        }
    `,
} as ButtonPresentationProps;
